import {Card, Heading, Link, Grid, EyebrowText} from '@primer/react-brand/esm'
import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'
import type {ImageLinkItem} from '../../types'
import {getAssetImageStyle, renderWithoutParagraphs} from '../../utils'
import type {Document} from '@contentful/rich-text-types'

export type FlexSuiteRiverFootstepsProps = {
  heading?: Document
  label?: string
  cta?: {href: string; text: string}
  cards?: ImageLinkItem[]
}

// This custom implementation will be replaced with a new Primer Brand Component, when available.
export function FlexSuiteRiverFootsteps({heading, label, cta, cards}: FlexSuiteRiverFootstepsProps) {
  const riverCards = cards?.map(c => {
    const id = c.sys.id
    const card = c.fields
    const imageUrl = card.image?.fields.file.url
    const imageAlt = card.image?.fields.description || ''
    const imageStyle = getAssetImageStyle(card.image)
    if (!imageUrl) return null
    return (
      <Grid.Column span={{small: 12, medium: 6}} key={id}>
        <Card href={card.href} fullWidth>
          <Card.Image
            as="picture"
            aspectRatio={imageStyle ? 'custom' : undefined}
            style={imageStyle}
            src={`${imageUrl}?fm=webp`}
            alt={imageAlt}
            sources={getImageSources(imageUrl, {maxWidth: MAX_CONTENT_WIDTH / 2})}
            loading="lazy"
          />
          {card.label && <Card.Label>{card.label}</Card.Label>}
          {card.heading && (
            <Card.Heading>
              {renderWithoutParagraphs(card.heading)}
              {card.alt ? <span className="sr-only"> {card.alt}</span> : null}
            </Card.Heading>
          )}
        </Card>
      </Grid.Column>
    )
  })
  return (
    <Grid>
      <Grid.Column span={{xsmall: 12, large: 5}}>
        {label && <EyebrowText>{label}</EyebrowText>}
        {heading && <Heading as="h3">{renderWithoutParagraphs(heading)}</Heading>}
        {cta && (
          <Link variant="accent" href={cta.href}>
            {cta.text}
          </Link>
        )}
      </Grid.Column>
      <Grid.Column span={{xsmall: 12, large: 7}}>
        <Grid>{riverCards}</Grid>
      </Grid.Column>
    </Grid>
  )
}
